import actionTypes from "./actionTypes";
import api from "./api";
import { getTasksLogDataForDocument } from "./selectors";
export default {
    setTasksLogsData: (items, documentId) => ({
        type: actionTypes.SET_TASKS_LOGS_DATA,
        items,
        documentId
    }),
    setTasksLogsSocketData: (items, documentId) => ({
        type: actionTypes.SET_TASKS_LOGS_SOCKET_DATA,
        items,
        documentId
    }),
    setLogLevels: (logLevels, documentId) => ({
        type: actionTypes.SET_LOG_LEVELS,
        logLevels,
        documentId
    }),
    setPresentationInterval: (interval) => ({
        type: actionTypes.SET_PRESENTATION_INTERVAL,
        interval
    }),
    setTimelineInterval: (interval) => ({
        type: actionTypes.SET_TIMELINE_INTERVAL,
        interval
    }),
    getTasksLogsDataForDocument: (documentId) => (dispatch, getState) => {
        const prevData = getTasksLogDataForDocument(getState(), documentId);
        if (prevData)
            return undefined;
        return dispatch({
            type: actionTypes.GET_TASKS_LOGS_DATA_FOR_DOCUMENT,
            payload: {
                promise: () => api.getTaskLogsForDocument(documentId)
            },
            scope: `${actionTypes.GET_TASKS_LOGS_DATA_FOR_DOCUMENT}_${documentId}`,
            meta: {
                documentId
            }
        });
    }
};
